import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-hearts',
    templateUrl: './hearts.component.html',
    styleUrls: ['./hearts.component.scss'],
    standalone: false
})
export class HeartsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
